import { includes } from 'lodash';

import { ITransfer } from '@app/shared/types/entities/transfer/transfer.type';
import { TRANSFER_UNSAVED_STATUS } from '../../transfer/transfer.definition';

const isHiddenRemoveButton = (item: ITransfer): boolean =>
  !includes(TRANSFER_UNSAVED_STATUS, item.status);

export { isHiddenRemoveButton };
